import { useAuth0 } from '@auth0/auth0-react';
import styles from './list.module.css';
import { useHistory } from "react-router-dom";
import { Edit, MoreVertical, Send, Trash2 } from 'react-feather';
import { Dropdown } from 'react-bootstrap';
import ApprovalBadge from '../../ApprovalBadge';
import { canSendUnlockLink, isRejectedRequest, isVehicleRow, rowPhotos, rowThumb } from '../../vehicleRows';
import ListThumb from '../../ListThumb';

// Mobile cards for the list and grid views; tapping a card opens the vehicle details (actions.openDetails)
const MobileViewList = ({ rowsData, actions, setTenantModalOpen, setTenantDetails }) => {
    const redirect = useHistory();
    const { user, isAuthenticated } = useAuth0();
    const permissions = (isAuthenticated && user?.["https://propertydek.com/permissions"]) || [];
    const canUpdate = permissions.indexOf("vehicle:update") > -1;

    const goToTenantetails = (row) => {
        if (permissions.indexOf("tenant-contactinfo:read") > -1 && permissions.indexOf("tenant-journey:read") > -1) {
            redirect.push("/people/tenants/details/" + row.tenant_id);
        } else {
            setTenantModalOpen(true);
            setTenantDetails(row?.tenant_details);
        }
    }

    return (<div className={`${styles.ListMobileView}`}>
        {rowsData.map((card) => {
            const isGuest = card.is_guest === 1;
            const isVehicle = isVehicleRow(card);
            const isRejected = isRejectedRequest(card);
            const thumb = rowThumb(card);
            // const showMenu = canUpdate && (isVehicle || !isGuest || isRejected);
            const showMenu = canUpdate && (isVehicle || isRejected);

            return (
                <div key={card.key} className={`${styles.MobileVehicleCardWrapper}`}>
                    <div className={`${styles.MobileVehicleMainCard}`} onClick={() => actions?.openDetails(card)} style={{ cursor: 'pointer' }}>
                        <div className={`${styles.MobileCarIconBox}`}>
                            {thumb ? <ListThumb thumb={thumb} full={rowPhotos(card)[0]?.url || thumb} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <img src="/static/img/car.svg" alt="" style={{ width: '40px', height: '40px', opacity: 0.7 }} />}
                            {card.isNew && (<span className={`${styles.MobileNewBadge}`}>New</span>)}
                        </div>

                        <div className={`${styles.MobileCardTextSec}`}>
                            <p className={`${styles.MobileCardTitle}`}>
                                {isGuest ? (
                                    <span style={{ color: '#ff8271', fontWeight: 600 }}>{card.name}</span>
                                ) : (
                                    <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); goToTenantetails(card); }}>{card.name}</span>
                                )}
                                {isGuest && <span className={styles.MobileGuestInlineBadge}>Guest</span>}
                            </p>

                            <p className={`${styles.MobileCardSub}`}>
                                {card.license}
                                {isGuest && card.tenant_name && <span> · guest of {card.tenant_name}</span>}
                            </p>
                            <p className={`${styles.MobileCardSub}`}>{[card.make, card.model, card.color].filter(Boolean).join(" · ")}</p>
                            <p className={`${styles.MobileCardProp}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (card.property_id) redirect.push("/properties/details/" + card.property_id); }}>{card.property} · {card.unit}</p>
                            <div className={`${styles.MobileApproval}`}>
                                <ApprovalBadge row={card} showSub={false} />
                            </div>
                        </div>

                        <div className={`${styles.MobileCardRightSec}`} style={{ alignSelf: 'center' }}>
                            {showMenu && (
                                <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id={`vehicle-mobile-actions-${card.key}`}>
                                        <MoreVertical />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                        {(isVehicle || isRejected) && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => (isRejected ? actions?.openEditRequest(card) : actions?.openEdit(card))}>
                                            <Edit /> Edit
                                        </Dropdown.Item>)}
                                        {/* Send update link is no longer used
                                        {!isGuest && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => actions?.openSendLink(card)}>
                                            <Send /> Send update link
                                        </Dropdown.Item>)} */}
                                        {canSendUnlockLink(card) && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => actions?.sendAccessLink(card)}>
                                          <Send /> Send unlock link (SMS)
                                        </Dropdown.Item>)}
                                        {(isVehicle || (isRejected && actions?.canDelete)) && (<Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={() => (isRejected ? actions?.openDeleteRequest(card) : actions?.openDelete(card))}>
                                            <Trash2 /> Delete
                                        </Dropdown.Item>)}
                                    </Dropdown.Menu>
                                </Dropdown>
                            )}
                        </div>
                    </div>
                </div>
            );
        })}
    </div>)
}

export default MobileViewList;
